// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".secnav__infopart{\n    margin: 1rem 10rem;\n}\n.info_loader{\n    margin: auto;\n}", "",{"version":3,"sources":["webpack://./src/pages/infopage/infopage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB","sourcesContent":[".secnav__infopart{\n    margin: 1rem 10rem;\n}\n.info_loader{\n    margin: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
